import { TableRowSingleButtonProps } from './TableRowSingleButton.types';
import * as S from './TableRowSingleButton.style';

const TableRowSingleButton = ({
  icon,
  testIdSuffix,
  title,
  size = 'M',
  variant = 'secondary',
  ...restButtonProps
}: TableRowSingleButtonProps) => {
  if (!icon) {
    return null;
  }

  return (
    <S.ActionButton
      icon={icon}
      size={size}
      variant={variant}
      title={title}
      data-testid={`button--${testIdSuffix}`}
      {...restButtonProps}
    />
  );
};
export default TableRowSingleButton;
